import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {VatTuService} from '@entities/vat-tu/vat-tu.service';
import {JhiEventManager} from 'ng-jhipster';

@Component({
  selector: 'app-vat-tu-delete-history-dialog',
  templateUrl: './vat-tu-delete-history-dialog.component.html',
})
export class VatTuDeleteHistoryDialogComponent {
  historyId: any;
  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }

  constructor(
    private dialogRef: MatDialogRef<VatTuDeleteHistoryDialogComponent>,
    private vattuService: VatTuService,
    private eventManager: JhiEventManager,
  ) {}

  confirmDelete() {
    this.vattuService.deleteHistory(this.historyId).subscribe((response) => {
      this.eventManager.broadcast({
        name: 'vattuListModification',
        content: 'VatTu',
      });
      this.eventManager.broadcast({
        name: 'vaiTroBlockDetailsModification',
        content: this.historyId,
      });
      this.dialogRef.close(true);
    });
  }
}

@Component({
  selector: 'app-delete-history',
  template: '',
})
export class VatTuDeleteHistoryPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<VatTuDeleteHistoryDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.vat-tu.vat-tu-delete-history-dialog.Xóa lịch sử vật tư_title',
      ),
    );
    this.activatedRoute.params.subscribe((param) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(VatTuDeleteHistoryDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        this.dialogRef.componentInstance.historyId = param.vattu;

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.dialogRef = null;
    this.titleService.setTitle(
      this.translate.instant(
        'entities.vat-tu.vat-tu-delete-history-dialog.Danh sách vật tư_title',
      ),
    );
  }
}
